module.exports = __webpack_public_path__ + "img/ai_speaking.f70ac6c1.png";